module.exports = __webpack_public_path__ + "img/yp2@2x.cb8032f9.png";